const routes = [
    {
        path: "/states",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "state_index"
        }
    }
];

export default routes;
